import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Customers from "@/pages/Customers";
import Suppliers from "@/pages/Suppliers";

/** Combined Parties page (Customers + Suppliers as tabs) per BillPro spec. */
export default function Parties() {
  return (
    <Tabs defaultValue="customers">
      <div className="mb-2">
        <h1 className="font-heading text-3xl font-bold tracking-tight">Parties</h1>
        <p className="text-sm text-muted-foreground mt-1">Customers and suppliers in one place</p>
      </div>
      <TabsList>
        <TabsTrigger value="customers" data-testid="tab-parties-customers">Customers</TabsTrigger>
        <TabsTrigger value="suppliers" data-testid="tab-parties-suppliers">Suppliers</TabsTrigger>
      </TabsList>
      <TabsContent value="customers" className="mt-4"><Customers /></TabsContent>
      <TabsContent value="suppliers" className="mt-4"><Suppliers /></TabsContent>
    </Tabs>
  );
}
